export const MonitorType = {
    1: '试验',
    2: '施工过程',
    3: '健康运营',
    4: '全过程',
}

export const MonitorTypeList = [
    { value: 1, label: '试验' },
    { value: 2, label: '施工过程' },
    { value: 3, label: '健康运营' },
    { value: 4, label: '全过程' },
]

export function getMonitorTypeLabel(value: number) {
    return MonitorTypeList.find(item => item.value === value)?.label || '';
}